import { createContext, useContext } from "react";
import { AlertContextType } from "./AlertTypes";

export const AlertContext = createContext<AlertContextType | null>(null);

export const useAlert = (): AlertContextType => {
    const context = useContext(AlertContext);
    if (!context) {
        throw new Error("useAlert must be used within AlertProvider");
    }
    return context;
};
